export const projectList = [
  {
    id: 1,
    name: '领导力提升项目',
    desc: '集行动学习，教练技术，复盘技术等高端学习方法论为一身，融合案例教学，微课开发，学习设计等先进方法论为一体，帮企业解决实际问题，支持管理沉淀，提升培训影响力，最终解决业务问题，促进公司发展。',
    img: require('../images/project_demo.png'),
  },
  {
    id: 2,
    name: '基于定制的内部讲师认证项目',
    desc: '课程成熟，得到广泛的认可：已在近千家企业成功实践，产品迭代36次；教练是组织长期发展的刚需：快速变化中的组织，需要教练来激发组织应变弹性；标准化、模块化的课程易于转化复制：完整的讲师手册、精心设计的表单步骤，内训师易上手。',
    img: require('../images/project_demo_2.png')
  },
  {
    id: 3,
    name: '教练型领导力项目',
    desc: '集行动学习，教练技术，复盘技术等高端学习方法论为一身，融合案例教学，微课开发，学习设计等先进方法论为一体，帮企业解决实际问题，支持管理沉淀，提升培训影响力，最终解决业务问题，促进公司发展。',
    img: require('../images/project_demo_3.png')
  },
  {
    id: 4,
    name: '导师制项目',
    desc: '导师制项目从“选育用留，评估管理，运营支持”3大系统提供导师制整体解决方案，整合组织内外部资源，实施导师制设计与运营支持，评估导师制项目成果。旨在帮助企业顺利实施导师制，正确理解导师的角色，提升导师能力，灵活运用多种带教工具，结合不同带教场景，培养高潜人才，发展继任计划，帮助组织以越来越高的水平提高绩效质量，形成人才梯队。',
    img: require('../images/project_demo_4.png')
  }
]